import type { ProjectStatus, SceneStatus } from "@shared/schema";

export function timeAgo(ts: number): string {
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60) return "щойно";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} хв тому`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} год тому`;
  const d = Math.floor(h / 24);
  return `${d} дн тому`;
}

export function secToTc(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export const PROJECT_STATUS_LABEL: Record<ProjectStatus, string> = {
  draft: "Чернетка",
  ingesting: "Завантаження референсу",
  analyzing: "Аналіз",
  planning: "Планування",
  planned: "Сплановано",
  generating: "Генерація",
  ready: "Готово до експорту",
  error: "Помилка",
};

export function projectBadgeClass(status: ProjectStatus): string {
  switch (status) {
    case "ready":
      return "green";
    case "error":
      return "red";
    case "generating":
    case "analyzing":
    case "planning":
    case "ingesting":
      return "amber";
    default:
      return "blue";
  }
}

export const SCENE_STATUS_LABEL: Record<SceneStatus, string> = {
  planned: "Заплановано",
  frame_queued: "Кадр у черзі",
  frame_ready: "Кадр готовий",
  video_queued: "Відео у черзі",
  video_ready: "Відео готове",
  error: "Помилка",
  skipped: "UI-екран (Figma/AE)",
};

export function sceneBadgeClass(status: SceneStatus): string {
  switch (status) {
    case "video_ready":
      return "green";
    case "error":
      return "red";
    case "frame_queued":
    case "video_queued":
      return "amber";
    case "skipped":
      return "amber";
    default:
      return "blue";
  }
}
